import { useEffect, useState } from "react";
import GOESLoading from "./common/logos/GOESLoading";
import { Icon } from "@elaniintc/goes-design-system";

const LoadingScreen = () => {
  const [showLoading, setShowLoading] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoading(true);
    }, 1000); // Show loading after 1 second

    return () => clearTimeout(timer); // Cleanup the timer on unmount
  }, []);

  return (
    <div className="w-screen h-screen bg-[#313945] flex items-center justify-center relative">
      <GOESLoading />
      {showLoading && (
        <div className="absolute left-0 right-0 bottom-8 animate-fade-in w-full flex items-center justify-center text-on-disabled">
          <Icon
            type="far"
            name="spinner-third"
            className="animate-spin text-xl text-current"
          />
        </div>
      )}
    </div>
  );
};

export default LoadingScreen;
